import { Text } from "tamagui";
import React from "react";
import { Header } from "../../components/design-system/Header";

import { EventsList } from "./EventsList";

export const Events = () => {
  return (
    <>
      <Header
        title="BC Events"
        subtitle="Offical Rides and Events by Breakfast Club"
      />

      <EventsList />
    </>
  );
};
